 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTCOPY from '@/components/Text/copy'
 import TEXTTB_TITLE from '@/components/Text/TB_title'
 import TEXTTB_COPY from '@/components/Text/TB_copy'
 import TEXTTB_NOTE from '@/components/Text/TB_note'
 import TEXTTB_GLOSSARY from '@/components/Text/TB_glossary'
 import TEXTTB_01 from '@/components/Text/TB_01'
 import TEXTTB_02 from '@/components/Text/TB_02'
 import TEXTTB_03 from '@/components/Text/TB_03'
 import TEXTTB_04 from '@/components/Text/TB_04'
 import TEXTTB_05 from '@/components/Text/TB_05'
 import TEXTTB_06 from '@/components/Text/TB_06'
 import TEXTTB_07 from '@/components/Text/TB_07'
 import TEXTTB_08 from '@/components/Text/TB_08'
 import TEXTTB_09 from '@/components/Text/TB_09'
 import TEXTTB_10 from '@/components/Text/TB_10'
 import TEXTTB_11 from '@/components/Text/TB_11'
 import TEXTTB_12 from '@/components/Text/TB_12'
 import TEXTTB_13 from '@/components/Text/TB_13'
 import TEXTTB_14 from '@/components/Text/TB_14'
 import TEXTTB_15 from '@/components/Text/TB_15'
 import TEXTTB_16 from '@/components/Text/TB_16'
 import TEXTTB_17 from '@/components/Text/TB_17'
 import TEXTTB_18 from '@/components/Text/TB_18'
 import TEXTTB_19 from '@/components/Text/TB_19'
 import TEXTTB_20 from '@/components/Text/TB_20'
 import TEXTTB_FURTHER from '@/components/Text/TB_further'
 import TEXTFFTITLE from '@/components/Text/FF-title'
 import TEXTFF_COPY from '@/components/Text/FF_copy'
 import TEXTFF_NOTE from '@/components/Text/FF_note'
 import TEXTFF_PRO from '@/components/Text/FF_pro'
 import TEXTFF_01 from '@/components/Text/FF_01'
 import TEXTFF_02 from '@/components/Text/FF_02'
 import TEXTFF_03 from '@/components/Text/FF_03'
 import TEXTFF_04 from '@/components/Text/FF_04'
 import TEXTFF_05 from '@/components/Text/FF_05'
 import TEXTFF_06 from '@/components/Text/FF_06'
 import TEXTFF_07 from '@/components/Text/FF_07'
 import TEXTFF_08 from '@/components/Text/FF_08'
 import TEXTFF_09 from '@/components/Text/FF_09'
 import TEXTFF_10 from '@/components/Text/FF_10'
 import TEXTFF_11 from '@/components/Text/FF_11'
 import TEXTFF_12 from '@/components/Text/FF_12'
 import TEXTFF_13 from '@/components/Text/FF_13'
 import TEXTFF_14 from '@/components/Text/FF_14'
 import TEXTFF_15 from '@/components/Text/FF_15'
 import TEXTFF_16 from '@/components/Text/FF_16'
 import TEXTFF_17 from '@/components/Text/FF_17'
 import TEXTFF_18 from '@/components/Text/FF_18'
 import TEXTFF_19 from '@/components/Text/FF_19'
 import TEXTFF_20 from '@/components/Text/FF_20'
 import TEXTFF_21 from '@/components/Text/FF_21'
 import LOVE_2 from '@/components/love_2'
 import TEXTFF_EPIL from '@/components/Text/FF_epil'
 import TEXTFF_AN from '@/components/Text/FF_an'
 import TEXTCC_TITLE from '@/components/Text/CC_title'
 import TEXTCC_COPY from '@/components/Text/CC_copy'
 import TEXTCC_GLOSSARY from '@/components/Text/CC_glossary'
 import TEXTCC_PRO from '@/components/Text/CC_pro'
 import TEXTCC_01 from '@/components/Text/CC_01'
 import TEXTCC_02 from '@/components/Text/CC_02'
 import TEXTCC_03 from '@/components/Text/CC_03'
 import TEXTCC_04 from '@/components/Text/CC_04'
 import TEXTCC_05 from '@/components/Text/CC_05'
 import TEXTCC_06 from '@/components/Text/CC_06'
 import TEXTCC_07 from '@/components/Text/CC_07'
 import TEXTCC_08 from '@/components/Text/CC_08'
 import TEXTCC_09 from '@/components/Text/CC_09'
 import TEXTCC_10 from '@/components/Text/CC_10'
 import TEXTCC_11 from '@/components/Text/CC_11'
 import TEXTCC_12 from '@/components/Text/CC_12'
 import TEXTCC_13 from '@/components/Text/CC_13'
 import TEXTCC_14 from '@/components/Text/CC_14'
 import TEXTCC_AN from '@/components/Text/CC_an'
 import TEXTMOREFROM from '@/components/Text/morefrom'
 import TEXTCONNECT from '@/components/Text/connect'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/Section0001",
 			"name" : "Text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/Text/copy",
 			"name" : "Text/copy",
 			"component" : TEXTCOPY
 		},
 		{
 			"path" : "/Text/TB_title",
 			"name" : "Text/TB_title",
 			"component" : TEXTTB_TITLE
 		},
 		{
 			"path" : "/Text/TB_copy",
 			"name" : "Text/TB_copy",
 			"component" : TEXTTB_COPY
 		},
 		{
 			"path" : "/Text/TB_note",
 			"name" : "Text/TB_note",
 			"component" : TEXTTB_NOTE
 		},
 		{
 			"path" : "/Text/TB_glossary",
 			"name" : "Text/TB_glossary",
 			"component" : TEXTTB_GLOSSARY
 		},
 		{
 			"path" : "/Text/TB_01",
 			"name" : "Text/TB_01",
 			"component" : TEXTTB_01
 		},
 		{
 			"path" : "/Text/TB_02",
 			"name" : "Text/TB_02",
 			"component" : TEXTTB_02
 		},
 		{
 			"path" : "/Text/TB_03",
 			"name" : "Text/TB_03",
 			"component" : TEXTTB_03
 		},
 		{
 			"path" : "/Text/TB_04",
 			"name" : "Text/TB_04",
 			"component" : TEXTTB_04
 		},
 		{
 			"path" : "/Text/TB_05",
 			"name" : "Text/TB_05",
 			"component" : TEXTTB_05
 		},
 		{
 			"path" : "/Text/TB_06",
 			"name" : "Text/TB_06",
 			"component" : TEXTTB_06
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js